import { getTestAttributes, slug } from '@chillibean/component-library';
import { icons } from '@chillibean/component-library/legacy';
import pluralize from 'pluralize';
import { Link, useHistory } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';

import StandardCard from '../../../../../../StandardCard/StandardCard';

function FormTemplateCard(props) {
  const {
    templateId,
    title,
    titleClass,
    active,
    numberOfLibraries,
    numberOfVersions,
    onDuplicate,
    handleShowActivationModal,
    workflowName,
  } = props;

  const librariesTooltip = `Available in ${numberOfLibraries} ${pluralize('Library', numberOfLibraries)}`;
  const versionsTooltip = `${numberOfVersions} ${pluralize('Version', numberOfVersions)} Tracked`;
  const workflowsTooltip = `Current Workflow: ${workflowName}`;
  const history = useHistory();

  const duplicate = (event) => {
    event.stopPropagation();
    onDuplicate(templateId);
  };

  const activate = (event) => {
    event.stopPropagation();
    handleShowActivationModal(templateId);
  };

  return (
    <StandardCard
      objectId={templateId}
      title={title}
      titleIcon={icons.edit(24, 24)}
      titleLink={`/${templateId}/edit`}
      titleClass={titleClass}
      active={active}
      clickHandler={() => history.push(`/${templateId}/edit`)}
    >
      <ReactTooltip
        place="top"
        type="dark"
        effect="solid"
        delayHide={500}
        textColor="#FFFFFF"
        backgroundColor="#6A6863"
        className=""
      />
      <div
        className="form-template-card__nav-item form-template-card__nav-item--link"
        {...getTestAttributes(`${slug(title)}-workflows-button`)}
      >
        <Link to={`/${templateId}/workflows`} data-tip={workflowsTooltip} onClick={(event) => event.stopPropagation()}>
          <span>Workflows</span>
          <i className="icon" aria-hidden="true">
            {icons.flowChart(26, 26)}
          </i>
        </Link>
      </div>
      <div
        className="form-template-card__nav-item form-template-card__nav-item--link"
        {...getTestAttributes(`${slug(title)}-versions-button`)}
      >
        <Link to={`/${templateId}/versions`} data-tip={versionsTooltip} onClick={(event) => event.stopPropagation()}>
          <span>Versions</span>
          <i className="icon" aria-hidden="true">
            {icons.clock(26, 26)}
          </i>
        </Link>
      </div>
      <div
        className="form-template-card__nav-item form-template-card__nav-item--link"
        {...getTestAttributes(`${slug(title)}-libraries-button`)}
      >
        <Link
          to={`/${templateId}/trial_containers`}
          data-tip={librariesTooltip}
          onClick={(event) => event.stopPropagation()}
        >
          <span>Libraries</span>
          <i className="icon" aria-hidden="true">
            {icons.folderPlusTwo(26, 26)}
          </i>
        </Link>
      </div>
      <div className="form-template-card__nav-item" {...getTestAttributes(`${slug(title)}-duplicate-button`)}>
        <a onClick={duplicate}>
          <span>Duplicate</span>
          <i className="icon" aria-hidden="true">
            {icons.copy(26, 26)}
          </i>
        </a>
      </div>
      <div className="form-template-card__nav-item" {...getTestAttributes(`${slug(title)}-active-button`)}>
        <a onClick={activate}>
          <span>Active</span>
          <i className="icon" aria-hidden="true">
            {active ? icons.checkSquare(26, 26) : icons.square(26, 26)}
          </i>
        </a>
      </div>
    </StandardCard>
  );
}
export default FormTemplateCard;
